<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Payment Transaction Events</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Payment Transaction Events</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <img src="/assets/images/loader.svg" alt="" />
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link
                  class="btn btn-info"
                  :to="{ name: 'PaymentTransactionEventList' }"
                >
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body table-responsive p-0">
              <table class="table table-striped">
                <tbody>
                  <tr>
                    <td><b>ID</b></td>
                    <td>{{ value.id }}</td>
                  </tr>

                  <tr>
                    <td><b>Event Type</b></td>
                    <td>{{ value.eventType }}</td>
                  </tr>

                  <tr>
                    <td><b>Event State</b></td>
                    <td>{{ value.eventState }}</td>
                  </tr>

                  <tr>
                    <td><b>Event Data</b></td>
                    <td>{{ value.eventData }}</td>
                  </tr>

                  <tr>
                    <td><b>Remarks</b></td>
                    <td>{{ value.remarks }}</td>
                  </tr>

                  <tr>
                    <td><b>Retry Counter</b></td>
                    <td>{{ value.retryCounter }}</td>
                  </tr>

                  <tr>
                    <td><b>Processing At</b></td>
                    <td>{{ value.processingAt }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import { DepartmentsAPI } from "@/services/api";
import axios from "axios";

export default {
  name: "PaymentTransactionEventShow",
  data: () => ({
    value: {},
    pre: {},
    is_loading: false,
  }),
  mounted: function () {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await this.getDetail(this.params.id).then((detail) => {
        this.value = detail;
      });

      this.is_loading = false;
    },
    getDetail: function (id) {
      let _this = this;
      return new Promise((resolve) => {
        let api_url = "/payment_transaction_event/" + id;
        _this.is_loading = true;
        axios
          .get(api_url)
          .then((response) => {
            _this.value = response.data;
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          })
          .finally(() => {
            _this.is_loading = false;
          });
      });
    },
  },
  created() {
    this.$emit("update:layout", MasterLayout);
  },
};
</script>
